import { cn } from '@/lib/utils'
import { Typo3Image } from '@/types/typo3'
import { BaseLink, Img, Title } from '@/ui/components'
import { memo } from 'react'
import { BaseLinkProps } from '../Base/type'

export interface CardMediaProps
  extends React.HTMLAttributes<HTMLAnchorElement | HTMLDivElement> {
  id?: string
  image?: Typo3Image
  title?: string
  subTitle?: string
  link?: BaseLinkProps
  crop?: {
    width: number
    height: number
  }
}

const LinkComponent = ({
  children,
  className,
  link,
  props
}: {
  children: React.ReactNode
  className: string
  link?: BaseLinkProps
  props?: BaseLinkProps
}) => {
  if (link) {
    return (
      <BaseLink {...link} className={cn(className)} {...props}>
        {children}
      </BaseLink>
    )
  } else {
    return <div className={className}>{children}</div>
  }
}

const CardMedia = ({ image, title, subTitle, link }: CardMediaProps) => (
  <LinkComponent
    className="p-xs bg-neutral-200 pb-0 text-neutral-600"
    link={link}
  >
    {image && (
      <div className="aspect-spacer bg-white">
        <Img
          data={image}
          className={'h-full w-full'}
          objectCover
          sizes="14rem"
        />
      </div>
    )}
    <div className={'p-xs'}>
      <Title as="h4" className="textstyle-sm-bold break-all uppercase">
        {title}
      </Title>
      {subTitle && <p className="textstyle-sm-regular break-all">{subTitle}</p>}
    </div>
  </LinkComponent>
)

CardMedia.displayName = 'CardMedia'

export default memo(CardMedia)
